import { useNavigate } from "react-router-dom";
import { Mail, Phone, Star } from "lucide-react";
import { Avatar } from "@/components/ContactRow";
import { fmtDate } from "@/lib/toto";

const stop = (e) => e.stopPropagation();

export default function ContactsTable({ contacts, catMap }) {
  const nav = useNavigate();
  return (
    <div className="t-card overflow-x-auto" data-testid="contacts-table">
      <table className="w-full table-fixed text-[14px] min-w-[980px]">
        <colgroup><col className="w-[26%]" /><col className="w-[20%]" /><col className="w-[14%]" /><col className="w-[16%]" /><col className="w-[12%]" /><col className="w-[12%]" /></colgroup>
        <thead>
          <tr className="text-left text-[12px] uppercase tracking-wide text-[#64748B] bg-[#F8FAFC] border-b border-[#E2E8F0]">
            {["Name", "Company", "Phone", "Category", "City", ""].map((h, i) => <th key={i} className="px-4 py-3 font-semibold">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {contacts.map((c) => (
            <tr key={c.id} onClick={() => nav(`/contacts/${c.id}`)} className="group border-b last:border-0 border-[#F1F5F9] cursor-pointer hover:bg-[#F5F5FF] transition-colors" data-testid={`contacts-table-row-${c.id}`}>
              <td className="px-4 py-3">
                <div className="flex items-center gap-3 min-w-0">
                  <Avatar name={c.name || c.companyName} size={38} />
                  <div className="min-w-0">
                    <p className="font-bold truncate flex items-center gap-1"><span className="truncate">{c.name || "—"}</span>{c.isFavorite && <Star className="w-3.5 h-3.5 shrink-0 fill-[#D97706] text-[#D97706]" />}</p>
                    <p className="text-[13px] text-[#64748B] truncate">{c.designation || c.email}</p>
                  </div>
                </div>
              </td>
              <td className="px-4 py-3 truncate" title={c.companyName}>{c.companyName || "—"}</td>
              <td className="px-4 py-3 truncate">{c.phone || "—"}</td>
              <td className="px-4 py-3">{catMap[c.categoryId] ? <span className="inline-block max-w-full truncate align-middle rounded-full bg-[#E5E5FD] text-[#0000EC] px-2.5 py-0.5 text-[12px] font-bold">{catMap[c.categoryId]}</span> : "—"}</td>
              <td className="px-4 py-3 truncate">{c.city || "—"}<span className="block text-[12px] text-[#94A3B8]">{fmtDate(c.createdAt)}</span></td>
              <td className="px-4 py-3">
                <div className="flex justify-end gap-1.5 opacity-60 group-hover:opacity-100 transition-opacity">
                  {c.phone && <a href={`tel:${c.phone.replace(/[^\d+]/g, "")}`} onClick={stop} className="w-9 h-9 rounded-full bg-[#E5E5FD] text-[#0000EC] flex items-center justify-center hover:bg-[#d8d8fc]" title="Call" data-testid={`table-call-${c.id}`}><Phone className="w-4 h-4" /></a>}
                  {c.email && <a href={`mailto:${c.email}`} onClick={stop} className="w-9 h-9 rounded-full bg-[#E5E5FD] text-[#0000EC] flex items-center justify-center hover:bg-[#d8d8fc]" title="Email" data-testid={`table-email-${c.id}`}><Mail className="w-4 h-4" /></a>}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
